/**
 * Generated Vessel Requirements from CSV Data
 * Generated on: 2025-10-06T19:31:45.414Z
 * Source: WBC3_VESSEL_REQUIREMENTS_DATABASE.csv and INLAND_WATERWAYS_REQUIREMENTS_DATABASE.csv
 * 
 * DO NOT EDIT THIS FILE DIRECTLY - It is auto-generated from CSV data
 * To update requirements, modify the CSV files and run: npm run update-requirements
 */

// Seagoing vessel requirements (WBC3)
export const seagoingRequirements = {
  "basicEquipment": [
    {
      "id": "equipment_vhf_radio_with_dsc",
      "name": "VHF Radio with DSC",
      "category": "Equipment",
      "reference": "Section 17.3",
      "description": "All vessels must have VHF with Digital Selective Calling",
      "priority": "Required",
      "status": "Basic",
      "module": "Communications",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_portable_vhf_radio_(min_1)",
      "name": "Portable VHF Radio (min 1)",
      "category": "Equipment",
      "reference": "Section 17.3",
      "description": "Waterproof portable radio",
      "priority": "Required",
      "status": "Basic",
      "module": "Communications",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_magnetic_compass",
      "name": "Magnetic Compass",
      "category": "Equipment",
      "reference": "Section 19.2",
      "description": "Primary navigation aid",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_navigation_lights",
      "name": "Navigation Lights",
      "category": "Equipment",
      "reference": "Section 20 / COLREGS",
      "description": "As per vessel size and type",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_sound_signals",
      "name": "Sound Signals",
      "category": "Equipment",
      "reference": "Section 20 / COLREGS",
      "description": "Whistle and bell as appropriate",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_day_shapes",
      "name": "Day Shapes",
      "category": "Equipment",
      "reference": "Section 20 / COLREGS",
      "description": "For signalling vessel status",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_lifejackets_110%",
      "name": "Lifejackets 110%",
      "category": "Equipment",
      "reference": "Section 14.2",
      "description": "100% + 10% spare required",
      "priority": "Required",
      "status": "Basic",
      "module": "LSA",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_lifebuoys",
      "name": "Lifebuoys",
      "category": "Equipment",
      "reference": "Section 14.3",
      "description": "Number based on vessel length",
      "priority": "Required",
      "status": "Basic",
      "module": "LSA",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_distress_flares",
      "name": "Distress Flares",
      "category": "Equipment",
      "reference": "Section 14.8",
      "description": "Quantity based on area category",
      "priority": "Required",
      "status": "Basic",
      "module": "LSA",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_fire_extinguishers",
      "name": "Fire Extinguishers",
      "category": "Equipment",
      "reference": "Section 15.3",
      "description": "Portable units as per spaces",
      "priority": "Required",
      "status": "Basic",
      "module": "FFE",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_fire_buckets_with_lanyards",
      "name": "Fire Buckets with Lanyards",
      "category": "Equipment",
      "reference": "Section 15.3",
      "description": "Sand/water buckets",
      "priority": "Required",
      "status": "Basic",
      "module": "FFE",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_first_aid_kit",
      "name": "First Aid Kit",
      "category": "Equipment",
      "reference": "Section 23.1",
      "description": "Category based on area",
      "priority": "Required",
      "status": "Basic",
      "module": "Medical",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_bilge_pumping",
      "name": "Bilge Pumping",
      "category": "Equipment",
      "reference": "Section 11.1",
      "description": "Manual or powered",
      "priority": "Required",
      "status": "Basic",
      "module": "Machinery",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    }
  ],
  "basicCertificates": [
    {
      "id": "certificate_workboat_certificate",
      "name": "Workboat Certificate",
      "category": "Certificate",
      "reference": "Section 3",
      "description": "Or special certificate (PO/PB)",
      "priority": "Required",
      "status": "Basic",
      "module": "Vessel",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "certificate_insurance_certificate",
      "name": "Insurance Certificate",
      "category": "Certificate",
      "reference": "Section 3.8",
      "description": "P&I or equivalent",
      "priority": "Required",
      "status": "Basic",
      "module": "Vessel",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "certificate_load_line_exemption",
      "name": "Load Line Exemption",
      "category": "Certificate",
      "reference": "Section 3.8",
      "description": "For vessels under 24m",
      "priority": "Required",
      "status": "Basic",
      "module": "Vessel",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    }
  ],
  "basicDocumentation": [
    {
      "id": "documentation_safety_management_system",
      "name": "Safety Management System",
      "category": "Documentation",
      "reference": "Section 31.2",
      "description": "Written SMS required",
      "priority": "Required",
      "status": "Basic",
      "module": "SMS",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_crew_list",
      "name": "Crew List",
      "category": "Documentation",
      "reference": "Section 28.1",
      "description": "Current crew manifest",
      "priority": "Required",
      "status": "Basic",
      "module": "Crew",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_hours_of_rest_records",
      "name": "Hours of Rest Records",
      "category": "Documentation",
      "reference": "MGN 505",
      "description": "Monthly records required",
      "priority": "Required",
      "status": "Basic",
      "module": "Crew",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_risk_assessments",
      "name": "Risk Assessments",
      "category": "Documentation",
      "reference": "Section 31.2",
      "description": "For all operations",
      "priority": "Required",
      "status": "Basic",
      "module": "SMS",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_drill_records",
      "name": "Drill Records",
      "category": "Documentation",
      "reference": "Section 14.1",
      "description": "Log of all drills conducted",
      "priority": "Required",
      "status": "Basic",
      "module": "Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_maintenance_records",
      "name": "Maintenance Records",
      "category": "Documentation",
      "reference": "Section 8",
      "description": "Equipment maintenance log",
      "priority": "Required",
      "status": "Basic",
      "module": "Maintenance",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    }
  ],
  "equipment": [
    {
      "id": "equipment_immersion_suits_for_all_persons",
      "name": "Immersion suits for ALL persons",
      "category": "Equipment",
      "reference": "Annex 3",
      "description": "Different from standard requirement",
      "priority": "Critical",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "equipment_4_white_illuminating_flares",
      "name": "4 white illuminating flares",
      "category": "Equipment",
      "reference": "Annex 3 Table 27.2.3",
      "description": "For night rescue operations",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "equipment_propeller_guards",
      "name": "Propeller guards",
      "category": "Equipment",
      "reference": "Annex 3",
      "description": "Protection for persons in water",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "equipment_immersion_suits_for_all_persons",
      "name": "Immersion suits for ALL persons",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "Table 27.2.3 requirement",
      "priority": "Critical",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_4_white_illuminating_flares",
      "name": "4 white illuminating flares",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "For emergency rescues at night",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_2_line_throwing_appliances",
      "name": "2 line throwing appliances",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "Half a set required",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_rescue_retrieval_equipment",
      "name": "Rescue retrieval equipment",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "Transom steps/ladder/scrambling net",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_propeller_guards",
      "name": "Propeller guards",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "Or alternative protection",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_2_buoyant_lifelines_(18m)",
      "name": "2 buoyant lifelines (18m)",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "With quoit secured to one end",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_storm_shutters_consideration",
      "name": "Storm shutters consideration",
      "category": "Equipment",
      "reference": "Section 27.2.3",
      "description": "Based on operating experience",
      "priority": "Optional",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "equipment_pa_system",
      "name": "PA System",
      "category": "Equipment",
      "reference": "General requirement",
      "description": "For safety announcements",
      "priority": "Required",
      "status": "Implemented",
      "module": "Communications",
      "triggerType": "Vessel Type",
      "triggerCondition": "Passenger (pax)"
    },
    {
      "id": "equipment_ais",
      "name": "AIS",
      "category": "Equipment",
      "reference": "General requirement",
      "description": "All passenger vessels regardless of tonnage",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Vessel Type",
      "triggerCondition": "Passenger (pax)"
    },
    {
      "id": "equipment_pa_system",
      "name": "PA System",
      "category": "Equipment",
      "reference": "Industry standard",
      "description": "For personnel transfer announcements",
      "priority": "Required",
      "status": "Implemented",
      "module": "Communications",
      "triggerType": "Vessel Type",
      "triggerCondition": "CTV"
    },
    {
      "id": "equipment_individual_inboard_seating",
      "name": "Individual inboard seating",
      "category": "Equipment",
      "reference": "Section 25.4.3",
      "description": "With lateral support for all persons",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Speed",
      "triggerCondition": "≥20 knots"
    },
    {
      "id": "equipment_mf_radio",
      "name": "MF Radio",
      "category": "Equipment",
      "reference": "Section 17",
      "description": "Medium Frequency radio",
      "priority": "Required",
      "status": "Implemented",
      "module": "Communications",
      "triggerType": "Area Category",
      "triggerCondition": "0-1"
    },
    {
      "id": "equipment_navtex_receiver",
      "name": "NAVTEX Receiver",
      "category": "Equipment",
      "reference": "Section 17",
      "description": "Navigation warnings",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_radar",
      "name": "Radar",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "Mandatory for Area 0-2",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_gps/dgps_(2_units)",
      "name": "GPS/DGPS (2 units)",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "Two units required",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_searchlight",
      "name": "Searchlight",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "For night operations",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_signalling_lamp",
      "name": "Signalling Lamp",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "Also Area 5",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-3"
    },
    {
      "id": "equipment_gps/dgps",
      "name": "GPS/DGPS",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "Single unit for Area 3-4",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-4"
    },
    {
      "id": "equipment_echo_sounder",
      "name": "Echo Sounder",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "Depth measurement",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "0-4"
    },
    {
      "id": "equipment_vhf_radio_with_dsc",
      "name": "VHF Radio with DSC",
      "category": "Equipment",
      "reference": "Section 17",
      "description": "All vessels",
      "priority": "Required",
      "status": "Implemented",
      "module": "Communications",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_portable_vhf_radio",
      "name": "Portable VHF Radio",
      "category": "Equipment",
      "reference": "Section 17",
      "description": "All vessels",
      "priority": "Required",
      "status": "Implemented",
      "module": "Communications",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_magnetic_compass",
      "name": "Magnetic Compass",
      "category": "Equipment",
      "reference": "Section 19",
      "description": "All vessels",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_navigation_lights",
      "name": "Navigation Lights",
      "category": "Equipment",
      "reference": "Section 20",
      "description": "All vessels",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_sound_signals",
      "name": "Sound Signals",
      "category": "Equipment",
      "reference": "Section 20",
      "description": "Whistle/horn/bell",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_day_shapes",
      "name": "Day Shapes",
      "category": "Equipment",
      "reference": "Section 20",
      "description": "All vessels",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Area Category",
      "triggerCondition": "All"
    },
    {
      "id": "equipment_ais",
      "name": "AIS",
      "category": "Equipment",
      "reference": "SOLAS requirement",
      "description": "Automatic Identification System",
      "priority": "Required",
      "status": "Implemented",
      "module": "Navigation",
      "triggerType": "Tonnage",
      "triggerCondition": "≥300 GT"
    },
    {
      "id": "equipment_fixed_fire_suppression_system",
      "name": "Fixed fire suppression system",
      "category": "Equipment",
      "reference": "Section 15.2.3",
      "description": "Automatic system for engine room",
      "priority": "Required",
      "status": "Implemented",
      "module": "Fire Safety",
      "triggerType": "Engine Position",
      "triggerCondition": "Below deck"
    },
    {
      "id": "equipment_general_alarm",
      "name": "General Alarm",
      "category": "Equipment",
      "reference": "General requirement",
      "description": "One of three GA triggers",
      "priority": "Required",
      "status": "Implemented",
      "module": "Safety",
      "triggerType": "Engine Power",
      "triggerCondition": ">750kW"
    },
    {
      "id": "equipment_general_alarm",
      "name": "General Alarm",
      "category": "Equipment",
      "reference": "General requirement",
      "description": "One of three GA triggers",
      "priority": "Required",
      "status": "Implemented",
      "module": "Safety",
      "triggerType": "Vessel Length",
      "triggerCondition": "≥24m"
    },
    {
      "id": "equipment_general_alarm",
      "name": "General Alarm",
      "category": "Equipment",
      "reference": "General requirement",
      "description": "One of three GA triggers",
      "priority": "Required",
      "status": "Implemented",
      "module": "Safety",
      "triggerType": "Max Persons",
      "triggerCondition": "≥16"
    },
    {
      "id": "equipment_hvac_system",
      "name": "HVAC system",
      "category": "Equipment",
      "reference": "Industry standard",
      "description": "Climate control",
      "priority": "Required",
      "status": "Implemented",
      "module": "Accommodation",
      "triggerType": "Operating Hours",
      "triggerCondition": ">24h"
    },
    {
      "id": "equipment_galley_equipment",
      "name": "Galley equipment",
      "category": "Equipment",
      "reference": "Industry standard",
      "description": "Food preparation",
      "priority": "Required",
      "status": "Implemented",
      "module": "Accommodation",
      "triggerType": "Operating Hours",
      "triggerCondition": ">24h"
    },
    {
      "id": "equipment_watermaker",
      "name": "Watermaker",
      "category": "Equipment",
      "reference": "Industry standard",
      "description": "Fresh water production",
      "priority": "Required",
      "status": "Implemented",
      "module": "Accommodation",
      "triggerType": "Operating Hours",
      "triggerCondition": ">24h"
    },
    {
      "id": "equipment_sewage_treatment",
      "name": "Sewage treatment",
      "category": "Equipment",
      "reference": "Industry standard",
      "description": "For accommodation spaces",
      "priority": "Required",
      "status": "Implemented",
      "module": "Environmental",
      "triggerType": "Operating Hours",
      "triggerCondition": ">24h + >4 persons"
    },
    {
      "id": "equipment_towing_arrangements",
      "name": "Towing arrangements",
      "category": "Equipment",
      "reference": "Section 26.2",
      "description": "Proper towing gear",
      "priority": "Required",
      "status": "Pending",
      "module": "Deck Equipment",
      "triggerType": "Operations",
      "triggerCondition": "Towing"
    },
    {
      "id": "equipment_pilot_ladder_arrangements",
      "name": "Pilot ladder arrangements",
      "category": "Equipment",
      "reference": "IMO requirements",
      "description": "If transferring to ships",
      "priority": "Required",
      "status": "Pending",
      "module": "Deck Equipment",
      "triggerType": "Operations",
      "triggerCondition": "Pilot transfer"
    },
    {
      "id": "equipment_battery_safety_systems",
      "name": "Battery safety systems",
      "category": "Equipment",
      "reference": "Annex 1",
      "description": "Ventilation and monitoring",
      "priority": "Critical",
      "status": "Pending",
      "module": "Safety Equipment",
      "triggerType": "Alternative Fuel",
      "triggerCondition": "Battery powered"
    },
    {
      "id": "equipment_406_mhz_epirb_with_gps",
      "name": "406 MHz EPIRB with GPS",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Float-free arrangement required",
      "priority": "Required",
      "status": "Pending",
      "module": "GMDSS",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_2_x_sart_units",
      "name": "2 x SART units",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Search and Rescue Transponders",
      "priority": "Required",
      "status": "Pending",
      "module": "GMDSS",
      "triggerType": "Area Category",
      "triggerCondition": "0-1"
    },
    {
      "id": "equipment_1_x_sart_unit",
      "name": "1 x SART unit",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Search and Rescue Transponder",
      "priority": "Required",
      "status": "Pending",
      "module": "GMDSS",
      "triggerType": "Area Category",
      "triggerCondition": "2"
    },
    {
      "id": "equipment_plb_for_each_crew_member",
      "name": "PLB for each crew member",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Personal Locator Beacons when on deck",
      "priority": "Required",
      "status": "Pending",
      "module": "GMDSS",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_2_x_portable_vhf_radios",
      "name": "2 x Portable VHF Radios",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Waterproof portable radios",
      "priority": "Required",
      "status": "Pending",
      "module": "Communications",
      "triggerType": "Area Category",
      "triggerCondition": "0-2"
    },
    {
      "id": "equipment_1_x_portable_vhf_radio",
      "name": "1 x Portable VHF Radio",
      "category": "Equipment",
      "reference": "Table 17.2.1",
      "description": "Waterproof portable radio",
      "priority": "Required",
      "status": "Pending",
      "module": "Communications",
      "triggerType": "Area Category",
      "triggerCondition": "3-6"
    },
    {
      "id": "equipment_diving_equipment",
      "name": "Diving Equipment",
      "category": "Equipment",
      "reference": "IMCA D014",
      "description": "Diving support equipment",
      "priority": "Required",
      "status": "Pending",
      "module": "Diving",
      "triggerType": "Operations",
      "triggerCondition": "Diving Support"
    },
    {
      "id": "equipment_motion_compensated_gangway",
      "name": "Motion Compensated Gangway",
      "category": "Equipment",
      "reference": "G+ requirements",
      "description": "Safe personnel transfer",
      "priority": "Required",
      "status": "Pending",
      "module": "Transfer",
      "triggerType": "Vessel Type",
      "triggerCondition": "Wind Farm CTV"
    },
    {
      "id": "equipment_bnwas",
      "name": "BNWAS",
      "category": "Equipment",
      "reference": "IMO requirements",
      "description": "Bridge Navigational Watch Alarm",
      "priority": "Required",
      "status": "Pending",
      "module": "Navigation",
      "triggerType": "Length",
      "triggerCondition": ">45m"
    },
    {
      "id": "equipment_vdr/s-vdr",
      "name": "VDR/S-VDR",
      "category": "Equipment",
      "reference": "IMO requirements",
      "description": "Voyage Data Recorder",
      "priority": "Required",
      "status": "Pending",
      "module": "Navigation",
      "triggerType": "Tonnage",
      "triggerCondition": ">300GT"
    },
    {
      "id": "equipment_work_wire_certificate",
      "name": "Work Wire Certificate",
      "category": "Equipment",
      "reference": "IMCA requirements",
      "description": "Certified anchor handling gear",
      "priority": "Required",
      "status": "Pending",
      "module": "Deck",
      "triggerType": "Operations",
      "triggerCondition": "Anchor Handling"
    },
    {
      "id": "equipment_gas_detection_system",
      "name": "Gas Detection System",
      "category": "Equipment",
      "reference": "IGF Code",
      "description": "LNG specific safety",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety",
      "triggerType": "Fuel Type",
      "triggerCondition": "LNG"
    },
    {
      "id": "equipment_dp_system_certificate",
      "name": "DP System Certificate",
      "category": "Equipment",
      "reference": "IMO MSC Circ 645",
      "description": "Dynamic positioning class",
      "priority": "Required",
      "status": "Pending",
      "module": "Navigation",
      "triggerType": "Operations",
      "triggerCondition": "DP Operations"
    }
  ],
  "certificates": [
    {
      "id": "certificate_police_boat_certificate_(po)",
      "name": "Police Boat Certificate (PO)",
      "category": "Certificate",
      "reference": "Annex 3",
      "description": "Different from standard WB certificate",
      "priority": "Critical",
      "status": "Pending",
      "module": "Certificates",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "certificate_pilot_boat_certificate_(pb)",
      "name": "Pilot Boat Certificate (PB)",
      "category": "Certificate",
      "reference": "Section 27.1",
      "description": "Or Workboat Certificate with Pilot Boat Endorsement",
      "priority": "Critical",
      "status": "Pending",
      "module": "Certificates",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "certificate_document_of_compliance",
      "name": "Document of Compliance",
      "category": "Certificate",
      "reference": "Section 29.2",
      "description": "For DG carriage",
      "priority": "Required",
      "status": "Pending",
      "module": "Certificates",
      "triggerType": "Operations",
      "triggerCondition": "Dangerous goods"
    }
  ],
  "documentation": [
    {
      "id": "documentation_stability_information_booklet",
      "name": "Stability Information Booklet",
      "category": "Documentation",
      "reference": "Section 27.2.3",
      "description": "Must meet section 12B.6",
      "priority": "Required",
      "status": "Pending",
      "module": "Documentation",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "documentation_dg_manifest",
      "name": "DG manifest",
      "category": "Documentation",
      "reference": "Section 29.3",
      "description": "Cargo documentation",
      "priority": "Required",
      "status": "Pending",
      "module": "Documentation",
      "triggerType": "Operations",
      "triggerCondition": "Dangerous goods"
    }
  ],
  "training": [
    {
      "id": "training_enhanced_lsa_familiarisation",
      "name": "Enhanced LSA familiarisation",
      "category": "Training",
      "reference": "Annex 3",
      "description": "Beyond standard familiarisation",
      "priority": "Critical",
      "status": "Pending",
      "module": "Familiarisation",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "training_law_enforcement_procedures",
      "name": "Law enforcement procedures",
      "category": "Training",
      "reference": "Annex 3",
      "description": "Specific to police operations",
      "priority": "Required",
      "status": "Pending",
      "module": "Training",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "training_dg_familiarisation",
      "name": "DG familiarisation",
      "category": "Training",
      "reference": "Section 29",
      "description": "Crew training requirement",
      "priority": "Required",
      "status": "Pending",
      "module": "Training",
      "triggerType": "Operations",
      "triggerCondition": "Dangerous goods"
    },
    {
      "id": "training_pilot_transfer_procedures",
      "name": "Pilot transfer procedures",
      "category": "Training",
      "reference": "Section 27",
      "description": "Safe transfer operations",
      "priority": "Required",
      "status": "Pending",
      "module": "Training",
      "triggerType": "Operations",
      "triggerCondition": "Pilot transfer"
    },
    {
      "id": "training_proficiency_in_survival_craft",
      "name": "Proficiency in Survival Craft",
      "category": "Training",
      "reference": "STCW VI/2-1",
      "description": "Required for lifeboat operators",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety",
      "triggerType": "Lifeboat Fitted",
      "triggerCondition": "Yes"
    },
    {
      "id": "training_proficiency_in_frb",
      "name": "Proficiency in FRB",
      "category": "Training",
      "reference": "STCW VI/2-2",
      "description": "Fast rescue boat certification",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety",
      "triggerType": "Fast Rescue Boat",
      "triggerCondition": "Yes"
    },
    {
      "id": "training_advanced_fire_fighting",
      "name": "Advanced Fire Fighting",
      "category": "Training",
      "reference": "STCW VI/3",
      "description": "Officers on vessels >500GT",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety",
      "triggerType": "Tonnage",
      "triggerCondition": ">500GT Officers"
    },
    {
      "id": "training_imdg_code_training",
      "name": "IMDG Code Training",
      "category": "Training",
      "reference": "IMDG Code",
      "description": "Dangerous goods handling",
      "priority": "Required",
      "status": "Pending",
      "module": "Cargo",
      "triggerType": "Operations",
      "triggerCondition": "Dangerous Goods"
    },
    {
      "id": "training_passenger_safety",
      "name": "Passenger Safety",
      "category": "Training",
      "reference": "STCW V/2",
      "description": "All crew on passenger vessels",
      "priority": "Required",
      "status": "Pending",
      "module": "Passenger",
      "triggerType": "Vessel Type",
      "triggerCondition": "Passenger"
    },
    {
      "id": "training_crowd_management",
      "name": "Crowd Management",
      "category": "Training",
      "reference": "STCW V/2",
      "description": "Managing passenger crowds",
      "priority": "Required",
      "status": "Pending",
      "module": "Passenger",
      "triggerType": "Passengers",
      "triggerCondition": ">12"
    },
    {
      "id": "training_crisis_management",
      "name": "Crisis Management",
      "category": "Training",
      "reference": "STCW V/2",
      "description": "Crisis and human behaviour",
      "priority": "Required",
      "status": "Pending",
      "module": "Passenger",
      "triggerType": "Vessel Type",
      "triggerCondition": "Passenger Officers"
    },
    {
      "id": "training_security_awareness",
      "name": "Security Awareness",
      "category": "Training",
      "reference": "STCW VI/6-1",
      "description": "All crew on ISPS vessels",
      "priority": "Required",
      "status": "Pending",
      "module": "Security",
      "triggerType": "ISPS",
      "triggerCondition": "Applicable"
    },
    {
      "id": "training_designated_security_duties",
      "name": "Designated Security Duties",
      "category": "Training",
      "reference": "STCW VI/6-2",
      "description": "Crew with security roles",
      "priority": "Required",
      "status": "Pending",
      "module": "Security",
      "triggerType": "ISPS",
      "triggerCondition": "Security Duties"
    },
    {
      "id": "training_diving_support_training",
      "name": "Diving Support Training",
      "category": "Training",
      "reference": "IMCA requirements",
      "description": "For diving support crew",
      "priority": "Required",
      "status": "Pending",
      "module": "Diving",
      "triggerType": "Operations",
      "triggerCondition": "Diving Support"
    },
    {
      "id": "training_offshore_petroleum_training",
      "name": "Offshore Petroleum Training",
      "category": "Training",
      "reference": "OPITO standards",
      "description": "Basic offshore safety",
      "priority": "Required",
      "status": "Pending",
      "module": "Offshore",
      "triggerType": "Vessel Type",
      "triggerCondition": "Offshore Supply"
    },
    {
      "id": "training_gwo_basic_safety",
      "name": "GWO Basic Safety",
      "category": "Training",
      "reference": "GWO standards",
      "description": "Global Wind Organisation training",
      "priority": "Required",
      "status": "Pending",
      "module": "Wind",
      "triggerType": "Vessel Type",
      "triggerCondition": "Wind Farm CTV"
    },
    {
      "id": "training_anchor_handling_training",
      "name": "Anchor Handling Training",
      "category": "Training",
      "reference": "IMCA requirements",
      "description": "AH operations training",
      "priority": "Required",
      "status": "Pending",
      "module": "Deck",
      "triggerType": "Operations",
      "triggerCondition": "Anchor Handling"
    },
    {
      "id": "training_igf_code_training",
      "name": "IGF Code Training",
      "category": "Training",
      "reference": "IGF Code",
      "description": "Gas fuel training",
      "priority": "Required",
      "status": "Pending",
      "module": "Safety",
      "triggerType": "Fuel Type",
      "triggerCondition": "LNG"
    },
    {
      "id": "training_dp_operator_certificate",
      "name": "DP Operator Certificate",
      "category": "Training",
      "reference": "NI requirements",
      "description": "DP operator qualification",
      "priority": "Required",
      "status": "Pending",
      "module": "Navigation",
      "triggerType": "Operations",
      "triggerCondition": "DP Operations"
    }
  ],
  "procedures": [
    {
      "id": "procedure_all_persons_seated_during_high-speed_ops",
      "name": "All persons seated during high-speed ops",
      "category": "Procedure",
      "reference": "Section 25.4.4",
      "description": "Or stood over jockey seats",
      "priority": "Required",
      "status": "Pending",
      "module": "Operating Procedures",
      "triggerType": "Speed",
      "triggerCondition": "≥20 knots"
    }
  ],
  "assessments": [
    {
      "id": "assessment_vibration_control_assessment",
      "name": "Vibration control assessment",
      "category": "Assessment",
      "reference": "Section 25.4.1 MGN 436",
      "description": "Whole body vibration assessment",
      "priority": "Required",
      "status": "Pending",
      "module": "Health & Safety",
      "triggerType": "Speed",
      "triggerCondition": "≥20 knots"
    }
  ],
  "riskAssessments": [
    {
      "id": "risk_assessment_police_operations_risk_assessment",
      "name": "Police operations risk assessment",
      "category": "Risk Assessment",
      "reference": "Annex 3",
      "description": "High-risk operations",
      "priority": "Required",
      "status": "Pending",
      "module": "Risk Assessment",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "risk_assessment_high-speed_operations_risk_assessment",
      "name": "High-speed operations risk assessment",
      "category": "Risk Assessment",
      "reference": "Section 25.4.2",
      "description": "Must be documented",
      "priority": "Required",
      "status": "Pending",
      "module": "Risk Assessment",
      "triggerType": "Speed",
      "triggerCondition": "≥20 knots"
    },
    {
      "id": "risk_assessment_dg_operations_risk_assessment",
      "name": "DG operations risk assessment",
      "category": "Risk Assessment",
      "reference": "Section 29",
      "description": "Stowage and segregation",
      "priority": "Required",
      "status": "Pending",
      "module": "Risk Assessment",
      "triggerType": "Operations",
      "triggerCondition": "Dangerous goods"
    },
    {
      "id": "risk_assessment_towing_operations_risk_assessment",
      "name": "Towing operations risk assessment",
      "category": "Risk Assessment",
      "reference": "Section 26.3",
      "description": "Must be documented",
      "priority": "Required",
      "status": "Pending",
      "module": "Risk Assessment",
      "triggerType": "Operations",
      "triggerCondition": "Towing"
    }
  ],
  "restrictions": [
    {
      "id": "restriction_no_petrol_engines_permitted",
      "name": "No petrol engines permitted",
      "category": "Restriction",
      "reference": "Annex 3",
      "description": "Need to enforce in engine type selection",
      "priority": "Critical",
      "status": "Implemented",
      "module": "Vessel Config",
      "triggerType": "Vessel Type",
      "triggerCondition": "Police Boat"
    },
    {
      "id": "restriction_no_petrol_engines_permitted",
      "name": "No petrol engines permitted",
      "category": "Restriction",
      "reference": "Section 27.2.3",
      "description": "Table 27.2.3 requirement",
      "priority": "Critical",
      "status": "Pending",
      "module": "Vessel Config",
      "triggerType": "Vessel Type",
      "triggerCondition": "Pilot Boat"
    },
    {
      "id": "restriction_no_sitting_on_gunwales_or_tubes",
      "name": "No sitting on gunwales or tubes",
      "category": "Restriction",
      "reference": "Section 25.4.5",
      "description": "RIB-specific restriction",
      "priority": "Critical",
      "status": "Pending",
      "module": "Operating Procedures",
      "triggerType": "Speed",
      "triggerCondition": "≥20 knots + RIB"
    }
  ],
  "areaCategoryEquipment": [],
  "crewCertificationByArea": []
};

// Inland waterways requirements
export const inlandRequirements = {
  "basicEquipment": [
    {
      "id": "equipment_vhf_radio",
      "name": "VHF Radio",
      "category": "Equipment",
      "description": "All vessels must have VHF radio for navigation safety",
      "priority": "Required",
      "status": "Basic",
      "module": "Communications",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_magnetic_compass",
      "name": "Magnetic Compass",
      "category": "Equipment",
      "description": "Primary navigation aid for all vessels",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_navigation_lights",
      "name": "Navigation Lights",
      "category": "Equipment",
      "description": "As per vessel size and type",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_sound_signals",
      "name": "Sound Signals",
      "category": "Equipment",
      "description": "Horn or whistle as per COLREGS",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_anchor_and_cable",
      "name": "Anchor and Cable",
      "category": "Equipment",
      "description": "Suitable for vessel size and operating area",
      "priority": "Required",
      "status": "Basic",
      "module": "Deck Equipment",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_mooring_equipment",
      "name": "Mooring Equipment",
      "category": "Equipment",
      "description": "Adequate mooring lines and fenders",
      "priority": "Required",
      "status": "Basic",
      "module": "Deck Equipment",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_bilge_pumping",
      "name": "Bilge Pumping",
      "category": "Equipment",
      "description": "Manual or powered bilge pump",
      "priority": "Required",
      "status": "Basic",
      "module": "Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "One per person on board",
      "priority": "Required",
      "status": "Basic",
      "module": "Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_lifebuoys",
      "name": "Lifebuoys",
      "category": "Equipment",
      "description": "At least one with line attached",
      "priority": "Required",
      "status": "Basic",
      "module": "Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_first_aid_kit",
      "name": "First Aid Kit",
      "category": "Equipment",
      "description": "Category C medical stores minimum",
      "priority": "Required",
      "status": "Basic",
      "module": "Medical",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_fire_extinguishers",
      "name": "Fire Extinguishers",
      "category": "Equipment",
      "description": "Number based on vessel length and type",
      "priority": "Required",
      "status": "Basic",
      "module": "Fire Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_emergency_steering",
      "name": "Emergency Steering",
      "category": "Equipment",
      "description": "Alternative steering method",
      "priority": "Required",
      "status": "Basic",
      "module": "Navigation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_means_of_re-boarding",
      "name": "Means of Re-boarding",
      "category": "Equipment",
      "description": "Ladder or other means to re-board from water",
      "priority": "Required",
      "status": "Basic",
      "module": "Safety",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    }
  ],
  "basicCertificates": [],
  "basicDocumentation": [
    {
      "id": "documentation_certificate_of_compliance",
      "name": "Certificate of Compliance",
      "category": "Documentation",
      "description": "Valid certificate for inland waterways operation",
      "priority": "Required",
      "status": "Basic",
      "module": "Certification",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_insurance_certificate",
      "name": "Insurance Certificate",
      "category": "Documentation",
      "description": "Valid third party liability insurance",
      "priority": "Required",
      "status": "Basic",
      "module": "Documentation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_crew_list",
      "name": "Crew List",
      "category": "Documentation",
      "description": "List of all crew members",
      "priority": "Required",
      "status": "Basic",
      "module": "Documentation",
      "triggerType": "ALL VESSELS",
      "triggerCondition": "Always"
    }
  ],
  "equipment": [
    {
      "id": "equipment_public_address_system",
      "name": "Public Address System",
      "category": "Equipment",
      "description": "PA system for passenger announcements",
      "priority": "Required",
      "status": "Passenger",
      "module": "Communications",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_general_alarm",
      "name": "General Alarm",
      "category": "Equipment",
      "description": "Seven short blasts followed by one long blast",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_passenger_counting",
      "name": "Passenger Counting",
      "category": "Equipment",
      "description": "System to count and record passengers",
      "priority": "Required",
      "status": "Passenger",
      "module": "Operations",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_stability_information",
      "name": "Stability Information",
      "category": "Equipment",
      "description": "Approved stability booklet on board",
      "priority": "Required",
      "status": "Passenger",
      "module": "Stability",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_damage_control_plan",
      "name": "Damage Control Plan",
      "category": "Equipment",
      "description": "Posted damage control information",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_emergency_lighting",
      "name": "Emergency Lighting",
      "category": "Equipment",
      "description": "Emergency lighting for escape routes",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_life_rafts",
      "name": "Life Rafts",
      "category": "Equipment",
      "description": "Capacity for 110% of persons on board",
      "priority": "Required",
      "status": "Passenger",
      "module": "LSA",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_fixed_fire_detection",
      "name": "Fixed Fire Detection",
      "category": "Equipment",
      "description": "Fire detection in machinery spaces",
      "priority": "Required",
      "status": "Passenger",
      "module": "Fire Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_fixed_fire_fighting",
      "name": "Fixed Fire Fighting",
      "category": "Equipment",
      "description": "Fixed system for machinery spaces",
      "priority": "Required",
      "status": "Passenger",
      "module": "Fire Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_disabled_access",
      "name": "Disabled Access",
      "category": "Equipment",
      "description": "Provision for persons of reduced mobility",
      "priority": "Required",
      "status": "Passenger",
      "module": "Access",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "One per person",
      "priority": "Required",
      "status": "Passenger",
      "module": "LSA",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_lifebuoys",
      "name": "Lifebuoys",
      "category": "Equipment",
      "description": "Based on vessel length",
      "priority": "Required",
      "status": "Passenger",
      "module": "LSA",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_first_aid_kit",
      "name": "First Aid Kit",
      "category": "Equipment",
      "description": "Category C medical stores",
      "priority": "Required",
      "status": "Passenger",
      "module": "Medical",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_fire_extinguishers",
      "name": "Fire Extinguishers",
      "category": "Equipment",
      "description": "Based on vessel length and machinery",
      "priority": "Required",
      "status": "Passenger",
      "module": "Fire Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_means_of_recovery",
      "name": "Means of Recovery",
      "category": "Equipment",
      "description": "Means to recover person from water",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_vhf_radio",
      "name": "VHF Radio",
      "category": "Equipment",
      "description": "Fixed VHF required",
      "priority": "Required",
      "status": "Passenger",
      "module": "Communications",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "equipment_work_equipment_guards",
      "name": "Work Equipment Guards",
      "category": "Equipment",
      "description": "Guards on all dangerous machinery",
      "priority": "Required",
      "status": "Workboat",
      "module": "Safety",
      "triggerType": "NON-PASSENGER",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_ppe",
      "name": "PPE",
      "category": "Equipment",
      "description": "Appropriate PPE for crew",
      "priority": "Required",
      "status": "Workboat",
      "module": "Safety",
      "triggerType": "NON-PASSENGER",
      "triggerCondition": "Always"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "150N buoyancy minimum",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "A"
    },
    {
      "id": "equipment_anchor",
      "name": "Anchor",
      "category": "Equipment",
      "description": "Lighter anchor acceptable for Category A",
      "priority": "Required",
      "status": "Category",
      "module": "Deck Equipment",
      "triggerType": "CATEGORY",
      "triggerCondition": "A"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "150N buoyancy minimum",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "B"
    },
    {
      "id": "equipment_navigation_lights",
      "name": "Navigation Lights",
      "category": "Equipment",
      "description": "As per COLREGS for inland waters",
      "priority": "Required",
      "status": "Category",
      "module": "Navigation",
      "triggerType": "CATEGORY",
      "triggerCondition": "B"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "150N or 275N based on operation",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "C"
    },
    {
      "id": "equipment_lifebuoys",
      "name": "Lifebuoys",
      "category": "Equipment",
      "description": "Additional lifebuoy required",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "C"
    },
    {
      "id": "equipment_distress_signals",
      "name": "Distress Signals",
      "category": "Equipment",
      "description": "Flares or other distress signals",
      "priority": "Required",
      "status": "Category",
      "module": "Safety",
      "triggerType": "CATEGORY",
      "triggerCondition": "C"
    },
    {
      "id": "equipment_epirb_or_plb",
      "name": "EPIRB or PLB",
      "category": "Equipment",
      "description": "Emergency beacon recommended",
      "priority": "Recommended",
      "status": "Category",
      "module": "Communications",
      "triggerType": "CATEGORY",
      "triggerCondition": "C"
    },
    {
      "id": "equipment_life_jackets",
      "name": "Life Jackets",
      "category": "Equipment",
      "description": "275N buoyancy minimum",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_lifebuoys",
      "name": "Lifebuoys",
      "category": "Equipment",
      "description": "2 lifebuoys minimum with lights",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_life_raft",
      "name": "Life Raft",
      "category": "Equipment",
      "description": "May be required based on operation",
      "priority": "Required",
      "status": "Category",
      "module": "LSA",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_distress_signals",
      "name": "Distress Signals",
      "category": "Equipment",
      "description": "Full set of distress signals",
      "priority": "Required",
      "status": "Category",
      "module": "Safety",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_epirb",
      "name": "EPIRB",
      "category": "Equipment",
      "description": "406MHz EPIRB required",
      "priority": "Required",
      "status": "Category",
      "module": "Communications",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_radar_reflector",
      "name": "Radar Reflector",
      "category": "Equipment",
      "description": "Radar reflector or AIS",
      "priority": "Required",
      "status": "Category",
      "module": "Navigation",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "equipment_oars_or_paddles",
      "name": "Oars or Paddles",
      "category": "Equipment",
      "description": "Alternative propulsion for small vessels",
      "priority": "Required",
      "status": "Size",
      "module": "Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "<5m"
    },
    {
      "id": "equipment_bailer",
      "name": "Bailer",
      "category": "Equipment",
      "description": "Bailer or manual pump",
      "priority": "Required",
      "status": "Size",
      "module": "Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "<5m"
    },
    {
      "id": "equipment_torch",
      "name": "Torch",
      "category": "Equipment",
      "description": "Waterproof torch",
      "priority": "Required",
      "status": "Size",
      "module": "Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "<5m"
    },
    {
      "id": "equipment_fire_extinguisher",
      "name": "Fire Extinguisher",
      "category": "Equipment",
      "description": "1 x 1kg dry powder minimum",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "5-7m"
    },
    {
      "id": "equipment_bilge_pump",
      "name": "Bilge Pump",
      "category": "Equipment",
      "description": "Manual bilge pump minimum",
      "priority": "Required",
      "status": "Size",
      "module": "Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "5-7m"
    },
    {
      "id": "equipment_anchor",
      "name": "Anchor",
      "category": "Equipment",
      "description": "Anchor weight based on vessel size",
      "priority": "Required",
      "status": "Size",
      "module": "Deck Equipment",
      "triggerType": "LENGTH",
      "triggerCondition": "5-7m"
    },
    {
      "id": "equipment_fire_extinguishers",
      "name": "Fire Extinguishers",
      "category": "Equipment",
      "description": "2 x 1kg dry powder minimum",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "7-12m"
    },
    {
      "id": "equipment_bilge_pump",
      "name": "Bilge Pump",
      "category": "Equipment",
      "description": "Powered bilge pump required",
      "priority": "Required",
      "status": "Size",
      "module": "Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "7-12m"
    },
    {
      "id": "equipment_life_raft",
      "name": "Life Raft",
      "category": "Equipment",
      "description": "Required if >60 minutes from shore",
      "priority": "Conditional",
      "status": "Size",
      "module": "LSA",
      "triggerType": "LENGTH",
      "triggerCondition": "7-12m"
    },
    {
      "id": "equipment_vhf_fixed",
      "name": "VHF Fixed",
      "category": "Equipment",
      "description": "Fixed VHF installation",
      "priority": "Required",
      "status": "Size",
      "module": "Communications",
      "triggerType": "LENGTH",
      "triggerCondition": "7-12m"
    },
    {
      "id": "equipment_fire_extinguishers",
      "name": "Fire Extinguishers",
      "category": "Equipment",
      "description": "3 x 2kg minimum plus engine room",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "equipment_fire_buckets",
      "name": "Fire Buckets",
      "category": "Equipment",
      "description": "2 fire buckets with lanyards",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "equipment_fixed_fire_system",
      "name": "Fixed Fire System",
      "category": "Equipment",
      "description": "Required for enclosed machinery spaces",
      "priority": "Conditional",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "equipment_life_raft",
      "name": "Life Raft",
      "category": "Equipment",
      "description": "Capacity for all persons",
      "priority": "Required",
      "status": "Size",
      "module": "LSA",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "equipment_epirb",
      "name": "EPIRB",
      "category": "Equipment",
      "description": "406MHz EPIRB",
      "priority": "Required",
      "status": "Size",
      "module": "Communications",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "equipment_fire_detection",
      "name": "Fire Detection",
      "category": "Equipment",
      "description": "Fire detection in machinery spaces",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "equipment_fixed_fire_fighting",
      "name": "Fixed Fire Fighting",
      "category": "Equipment",
      "description": "Fixed system for machinery spaces",
      "priority": "Required",
      "status": "Size",
      "module": "Fire Safety",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "equipment_additional_life_raft",
      "name": "Additional Life Raft",
      "category": "Equipment",
      "description": "Sufficient capacity each side",
      "priority": "Required",
      "status": "Size",
      "module": "LSA",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "equipment_gmdss_equipment",
      "name": "GMDSS Equipment",
      "category": "Equipment",
      "description": "Full GMDSS suite",
      "priority": "Required",
      "status": "Size",
      "module": "Communications",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "equipment_emergency_generator",
      "name": "Emergency Generator",
      "category": "Equipment",
      "description": "Emergency power source",
      "priority": "Required",
      "status": "Size",
      "module": "Electrical",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "equipment_fire_extinguisher_co2",
      "name": "Fire Extinguisher CO2",
      "category": "Equipment",
      "description": "CO2 extinguisher for petrol engines",
      "priority": "Required",
      "status": "Engine",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Petrol"
    },
    {
      "id": "equipment_flame_arrestor",
      "name": "Flame Arrestor",
      "category": "Equipment",
      "description": "On air intakes",
      "priority": "Required",
      "status": "Engine",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Petrol"
    },
    {
      "id": "equipment_ventilation",
      "name": "Ventilation",
      "category": "Equipment",
      "description": "Forced ventilation for petrol engines",
      "priority": "Required",
      "status": "Engine",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Petrol"
    },
    {
      "id": "equipment_fire_extinguisher",
      "name": "Fire Extinguisher",
      "category": "Equipment",
      "description": "Foam or dry powder",
      "priority": "Required",
      "status": "Engine",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Diesel"
    },
    {
      "id": "equipment_fuel_shut-offs",
      "name": "Fuel Shut-offs",
      "category": "Equipment",
      "description": "Remote fuel shut-off valves",
      "priority": "Required",
      "status": "Engine",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Diesel"
    },
    {
      "id": "equipment_drip_trays",
      "name": "Drip Trays",
      "category": "Equipment",
      "description": "Under fuel filters and pumps",
      "priority": "Required",
      "status": "Engine",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Diesel"
    },
    {
      "id": "equipment_fixed_fire_system",
      "name": "Fixed Fire System",
      "category": "Equipment",
      "description": "Fixed fire suppression required",
      "priority": "Required",
      "status": "Power",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": ">100kW"
    },
    {
      "id": "equipment_engine_room_ventilation",
      "name": "Engine Room Ventilation",
      "category": "Equipment",
      "description": "Mechanical ventilation required",
      "priority": "Required",
      "status": "Power",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": ">100kW"
    },
    {
      "id": "equipment_oil/water_separator",
      "name": "Oil/Water Separator",
      "category": "Equipment",
      "description": "Oily water separator or holding tank",
      "priority": "Required",
      "status": "Power",
      "module": "Pollution",
      "triggerType": "ENGINE",
      "triggerCondition": ">100kW"
    },
    {
      "id": "equipment_co2_fixed_system",
      "name": "CO2 Fixed System",
      "category": "Equipment",
      "description": "CO2 or equivalent system",
      "priority": "Required",
      "status": "Power",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": ">750kW"
    },
    {
      "id": "equipment_fire_detection",
      "name": "Fire Detection",
      "category": "Equipment",
      "description": "Automatic fire detection",
      "priority": "Required",
      "status": "Power",
      "module": "Fire Safety",
      "triggerType": "ENGINE",
      "triggerCondition": ">750kW"
    },
    {
      "id": "equipment_emergency_stops",
      "name": "Emergency Stops",
      "category": "Equipment",
      "description": "Remote emergency stops",
      "priority": "Required",
      "status": "Power",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": ">750kW"
    },
    {
      "id": "equipment_kill_cord",
      "name": "Kill Cord",
      "category": "Equipment",
      "description": "Engine kill cord required",
      "priority": "Required",
      "status": "Manning",
      "module": "Safety",
      "triggerType": "MANNING",
      "triggerCondition": "Single-handed"
    },
    {
      "id": "equipment_mob_recovery",
      "name": "MOB Recovery",
      "category": "Equipment",
      "description": "Means to self-recover",
      "priority": "Required",
      "status": "Manning",
      "module": "Safety",
      "triggerType": "MANNING",
      "triggerCondition": "Single-handed"
    },
    {
      "id": "equipment_plb",
      "name": "PLB",
      "category": "Equipment",
      "description": "Personal locator beacon",
      "priority": "Required",
      "status": "Manning",
      "module": "Communications",
      "triggerType": "MANNING",
      "triggerCondition": "Single-handed"
    },
    {
      "id": "equipment_navigation_lights",
      "name": "Navigation Lights",
      "category": "Equipment",
      "description": "Full navigation lights",
      "priority": "Required",
      "status": "Operations",
      "module": "Navigation",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Night"
    },
    {
      "id": "equipment_search_light",
      "name": "Search Light",
      "category": "Equipment",
      "description": "Powerful searchlight",
      "priority": "Required",
      "status": "Operations",
      "module": "Navigation",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Night"
    },
    {
      "id": "equipment_night_vision",
      "name": "Night Vision",
      "category": "Equipment",
      "description": "Night vision equipment",
      "priority": "Recommended",
      "status": "Operations",
      "module": "Navigation",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Night"
    },
    {
      "id": "equipment_towing_gear",
      "name": "Towing Gear",
      "category": "Equipment",
      "description": "Certified towing equipment",
      "priority": "Required",
      "status": "Operations",
      "module": "Deck Equipment",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Towing"
    },
    {
      "id": "equipment_emergency_release",
      "name": "Emergency Release",
      "category": "Equipment",
      "description": "Quick release mechanism",
      "priority": "Required",
      "status": "Operations",
      "module": "Safety",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Towing"
    },
    {
      "id": "equipment_cold_weather_gear",
      "name": "Cold Weather Gear",
      "category": "Equipment",
      "description": "Appropriate cold weather PPE",
      "priority": "Required",
      "status": "Season",
      "module": "Safety",
      "triggerType": "SEASON",
      "triggerCondition": "Winter"
    },
    {
      "id": "equipment_ice_equipment",
      "name": "Ice Equipment",
      "category": "Equipment",
      "description": "Ice poles/equipment if ice risk",
      "priority": "Conditional",
      "status": "Season",
      "module": "Deck Equipment",
      "triggerType": "SEASON",
      "triggerCondition": "Winter"
    },
    {
      "id": "equipment_heating",
      "name": "Heating",
      "category": "Equipment",
      "description": "Adequate heating for crew",
      "priority": "Required",
      "status": "Season",
      "module": "Comfort",
      "triggerType": "SEASON",
      "triggerCondition": "Winter"
    }
  ],
  "certificates": [],
  "documentation": [
    {
      "id": "documentation_passenger_ship_certificate",
      "name": "Passenger Ship Certificate",
      "category": "Documentation",
      "description": "Required for all passenger vessels >12 pax",
      "priority": "Required",
      "status": "Passenger",
      "module": "Certification",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "documentation_safety_management_system",
      "name": "Safety Management System",
      "category": "Documentation",
      "description": "Full DSM compliance required",
      "priority": "Required",
      "status": "Passenger",
      "module": "SMS",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "documentation_dsm_certificate",
      "name": "DSM Certificate",
      "category": "Documentation",
      "description": "Domestic Safety Management Certificate",
      "priority": "Required",
      "status": "Passenger",
      "module": "SMS",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "documentation_passenger_manifest",
      "name": "Passenger Manifest",
      "category": "Documentation",
      "description": "Names of all passengers",
      "priority": "Required",
      "status": "Passenger",
      "module": "Documentation",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "documentation_route_risk_assessment",
      "name": "Route Risk Assessment",
      "category": "Documentation",
      "description": "Risk assessment for operating route",
      "priority": "Required",
      "status": "Passenger",
      "module": "SMS",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "documentation_small_passenger_boat_certificate",
      "name": "Small Passenger Boat Certificate",
      "category": "Documentation",
      "description": "Certificate for vessels ≤12 passengers",
      "priority": "Required",
      "status": "Passenger",
      "module": "Certification",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "documentation_passenger_safety_card",
      "name": "Passenger Safety Card",
      "category": "Documentation",
      "description": "Safety information for passengers",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "documentation_operating_procedures",
      "name": "Operating Procedures",
      "category": "Documentation",
      "description": "Written operating procedures",
      "priority": "Required",
      "status": "Passenger",
      "module": "Operations",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "documentation_workboat_certificate",
      "name": "Workboat Certificate",
      "category": "Documentation",
      "description": "Certificate of compliance for workboats",
      "priority": "Required",
      "status": "Workboat",
      "module": "Certification",
      "triggerType": "NON-PASSENGER",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_risk_assessments",
      "name": "Risk Assessments",
      "category": "Documentation",
      "description": "Risk assessments for work activities",
      "priority": "Required",
      "status": "Workboat",
      "module": "Safety",
      "triggerType": "NON-PASSENGER",
      "triggerCondition": "Always"
    },
    {
      "id": "documentation_category_endorsement",
      "name": "Category Endorsement",
      "category": "Documentation",
      "description": "Certificate endorsed for Category A",
      "priority": "Required",
      "status": "Category",
      "module": "Certification",
      "triggerType": "CATEGORY",
      "triggerCondition": "A"
    },
    {
      "id": "documentation_category_endorsement",
      "name": "Category Endorsement",
      "category": "Documentation",
      "description": "Certificate endorsed for Category B",
      "priority": "Required",
      "status": "Category",
      "module": "Certification",
      "triggerType": "CATEGORY",
      "triggerCondition": "B"
    },
    {
      "id": "documentation_category_endorsement",
      "name": "Category Endorsement",
      "category": "Documentation",
      "description": "Certificate endorsed for Category C",
      "priority": "Required",
      "status": "Category",
      "module": "Certification",
      "triggerType": "CATEGORY",
      "triggerCondition": "C"
    },
    {
      "id": "documentation_category_endorsement",
      "name": "Category Endorsement",
      "category": "Documentation",
      "description": "Certificate endorsed for Category D",
      "priority": "Required",
      "status": "Category",
      "module": "Certification",
      "triggerType": "CATEGORY",
      "triggerCondition": "D"
    },
    {
      "id": "documentation_stability_information",
      "name": "Stability Information",
      "category": "Documentation",
      "description": "Basic stability information",
      "priority": "Required",
      "status": "Size",
      "module": "Stability",
      "triggerType": "LENGTH",
      "triggerCondition": "12-24m"
    },
    {
      "id": "documentation_stability_booklet",
      "name": "Stability Booklet",
      "category": "Documentation",
      "description": "Approved stability booklet",
      "priority": "Required",
      "status": "Size",
      "module": "Stability",
      "triggerType": "LENGTH",
      "triggerCondition": ">24m"
    },
    {
      "id": "documentation_gas_safety_certificate",
      "name": "Gas Safety Certificate",
      "category": "Documentation",
      "description": "Annual gas safety check",
      "priority": "Required",
      "status": "Engine",
      "module": "Safety",
      "triggerType": "ENGINE",
      "triggerCondition": "Petrol"
    },
    {
      "id": "documentation_machinery_maintenance",
      "name": "Machinery Maintenance",
      "category": "Documentation",
      "description": "Planned maintenance system",
      "priority": "Required",
      "status": "Power",
      "module": "Maintenance",
      "triggerType": "ENGINE",
      "triggerCondition": ">750kW"
    },
    {
      "id": "documentation_float_plan",
      "name": "Float Plan",
      "category": "Documentation",
      "description": "Filed float plan required",
      "priority": "Required",
      "status": "Manning",
      "module": "Operations",
      "triggerType": "MANNING",
      "triggerCondition": "Single-handed"
    },
    {
      "id": "documentation_crew_duties",
      "name": "Crew Duties",
      "category": "Documentation",
      "description": "Defined crew responsibilities",
      "priority": "Required",
      "status": "Manning",
      "module": "Operations",
      "triggerType": "MANNING",
      "triggerCondition": "Multi-crew"
    },
    {
      "id": "documentation_watch_schedule",
      "name": "Watch Schedule",
      "category": "Documentation",
      "description": "If continuous operation",
      "priority": "Required",
      "status": "Manning",
      "module": "Operations",
      "triggerType": "MANNING",
      "triggerCondition": "Multi-crew"
    },
    {
      "id": "documentation_night_procedures",
      "name": "Night Procedures",
      "category": "Documentation",
      "description": "Written night operating procedures",
      "priority": "Required",
      "status": "Operations",
      "module": "Operations",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Night"
    },
    {
      "id": "documentation_towing_procedures",
      "name": "Towing Procedures",
      "category": "Documentation",
      "description": "Written towing procedures",
      "priority": "Required",
      "status": "Operations",
      "module": "Operations",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Towing"
    },
    {
      "id": "documentation_towing_endorsement",
      "name": "Towing Endorsement",
      "category": "Documentation",
      "description": "Certificate endorsed for towing",
      "priority": "Required",
      "status": "Operations",
      "module": "Certification",
      "triggerType": "OPERATIONS",
      "triggerCondition": "Towing"
    },
    {
      "id": "documentation_winter_procedures",
      "name": "Winter Procedures",
      "category": "Documentation",
      "description": "Winter operating procedures",
      "priority": "Required",
      "status": "Season",
      "module": "Operations",
      "triggerType": "SEASON",
      "triggerCondition": "Winter"
    },
    {
      "id": "documentation_boatmaster_licence",
      "name": "Boatmaster Licence",
      "category": "Documentation",
      "description": "Valid boatmaster licence",
      "priority": "Required",
      "status": "Manning",
      "module": "Certification",
      "triggerType": "BOATMASTER",
      "triggerCondition": "All"
    },
    {
      "id": "documentation_medical_certificate",
      "name": "Medical Certificate",
      "category": "Documentation",
      "description": "Valid medical certificate",
      "priority": "Required",
      "status": "Manning",
      "module": "Medical",
      "triggerType": "BOATMASTER",
      "triggerCondition": "All"
    }
  ],
  "training": [
    {
      "id": "training_dsm_audits",
      "name": "DSM Audits",
      "category": "Training",
      "description": "Initial and intermediate audits required",
      "priority": "Required",
      "status": "Passenger",
      "module": "SMS",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "training_muster_list",
      "name": "Muster List",
      "category": "Training",
      "description": "Posted muster list with crew duties",
      "priority": "Required",
      "status": "Passenger",
      "module": "Safety",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "training_passenger_safety_briefing",
      "name": "Passenger Safety Briefing",
      "category": "Training",
      "description": "Safety briefing before departure",
      "priority": "Required",
      "status": "Passenger",
      "module": "Operations",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "training_emergency_drills",
      "name": "Emergency Drills",
      "category": "Training",
      "description": "Weekly drills if in service",
      "priority": "Required",
      "status": "Passenger",
      "module": "Training",
      "triggerType": "PASSENGER",
      "triggerCondition": ">12"
    },
    {
      "id": "training_safety_briefing",
      "name": "Safety Briefing",
      "category": "Training",
      "description": "Briefing before departure",
      "priority": "Required",
      "status": "Passenger",
      "module": "Operations",
      "triggerType": "PASSENGER",
      "triggerCondition": "<=12"
    },
    {
      "id": "training_safe_working_practices",
      "name": "Safe Working Practices",
      "category": "Training",
      "description": "Training in safe working procedures",
      "priority": "Required",
      "status": "Workboat",
      "module": "Training",
      "triggerType": "NON-PASSENGER",
      "triggerCondition": "Always"
    },
    {
      "id": "training_emergency_drills",
      "name": "Emergency Drills",
      "category": "Training",
      "description": "Regular emergency drills",
      "priority": "Required",
      "status": "Manning",
      "module": "Training",
      "triggerType": "MANNING",
      "triggerCondition": "Multi-crew"
    },
    {
      "id": "training_local_knowledge",
      "name": "Local Knowledge",
      "category": "Training",
      "description": "Local knowledge endorsement",
      "priority": "Required",
      "status": "Manning",
      "module": "Training",
      "triggerType": "BOATMASTER",
      "triggerCondition": "All"
    },
    {
      "id": "training_refresher_training",
      "name": "Refresher Training",
      "category": "Training",
      "description": "5-yearly refresher training",
      "priority": "Required",
      "status": "Manning",
      "module": "Training",
      "triggerType": "BOATMASTER",
      "triggerCondition": "All"
    }
  ],
  "procedures": [],
  "assessments": [],
  "riskAssessments": [],
  "restrictions": [],
  "areaCategoryEquipment": [],
  "crewCertificationByArea": []
};

/**
 * Get vessel requirements based on configuration
 * @param {Object} vesselConfig - Vessel configuration object
 * @returns {Object} Requirements object with all applicable requirements
 */
export function getGeneratedVesselRequirements(vesselConfig) {
  const isInland = vesselConfig.operatingStatus === 'inland';
  const baseRequirements = isInland ? inlandRequirements : seagoingRequirements;
  
  // Filter requirements based on vessel config
  const applicableRequirements = {};
  
  Object.keys(baseRequirements).forEach(category => {
    applicableRequirements[category] = baseRequirements[category].filter(req => {
      return checkRequirementApplies(req, vesselConfig);
    });
  });
  
  return applicableRequirements;
}

/**
 * Check if a requirement applies to the vessel
 */
function checkRequirementApplies(req, vesselConfig) {
  // ALL VESSELS requirements always apply
  if (req.triggerType === 'ALL VESSELS') {
    return true;
  }
  
  // AREA based requirements
  if (req.triggerType === 'AREA') {
    const category = vesselConfig.category;
    const condition = req.triggerCondition;
    
    if (condition.includes('0-2')) {
      return category <= 2;
    } else if (condition.includes('0-4')) {
      return category <= 4;
    } else if (condition.includes(category)) {
      return true;
    }
  }
  
  // PASSENGER vessel requirements
  if (req.triggerType === 'PASSENGER') {
    const isPassenger = vesselConfig.vesselType === 'pax' || vesselConfig.carriesPassengers;
    if (!isPassenger) return false;
    
    if (req.triggerCondition === '>12') {
      return vesselConfig.passengerCapacity > 12;
    } else if (req.triggerCondition === '<=12') {
      return vesselConfig.passengerCapacity <= 12;
    }
    return isPassenger;
  }
  
  // LENGTH based requirements
  if (req.triggerType === 'LENGTH') {
    const length = parseFloat(vesselConfig.lengthOverall) || 0;
    const condition = req.triggerCondition;
    
    if (condition.includes('<')) {
      const value = parseFloat(condition.replace(/[<m]/g, ''));
      return length < value;
    } else if (condition.includes('>')) {
      const value = parseFloat(condition.replace(/[>m]/g, ''));
      return length > value;
    }
  }
  
  // ENGINE based requirements
  if (req.triggerType === 'ENGINE') {
    if (req.triggerCondition.includes('kW')) {
      const power = parseFloat(vesselConfig.enginePower) || 0;
      const value = parseFloat(req.triggerCondition.replace(/[>kW]/g, ''));
      return power > value;
    }
  }
  
  // OPERATIONS based requirements
  if (req.triggerType === 'OPERATIONS') {
    return vesselConfig.operations?.includes(req.triggerCondition.toLowerCase().replace(' ', '_'));
  }
  
  return false;
}
